import * as React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Breadcrumbs as MuiBreadcrumbs, Link, Typography } from "@mui/material";
import { MaterialSymbol } from "@datalake/towercontrol-banner";

// Section > Details > <id> — mandatory on detail pages (ALE design system).
export default function Breadcrumbs({ pathname, sectionLabel }) {
  const [section, ...rest] = pathname.split("/").filter(Boolean);
  if (!section || rest.length === 0) return null;

  const crumbs = [
    { label: sectionLabel || section, to: `/${section}` },
    ...rest.map((segment, i) => ({
      label: segment === "details" ? "Details" : decodeURIComponent(segment),
      to:
        segment === "details"
          ? null
          : `/${[section, ...rest.slice(0, i + 1)].join("/")}`,
    })),
  ];

  return (
    <MuiBreadcrumbs
      aria-label="breadcrumb"
      separator={<MaterialSymbol name="chevron_right" size="inline" />}
      sx={{ mb: 1 }}
    >
      {crumbs.map((crumb, i) =>
        i === crumbs.length - 1 || !crumb.to ? (
          <Typography
            key={i}
            variant="body2"
            color={i === crumbs.length - 1 ? "text.primary" : "text.secondary"}
            aria-current={i === crumbs.length - 1 ? "page" : undefined}
            sx={{ wordBreak: "break-all" }}
          >
            {crumb.label}
          </Typography>
        ) : (
          <Link key={i} component={RouterLink} to={crumb.to} variant="body2">
            {crumb.label}
          </Link>
        ),
      )}
    </MuiBreadcrumbs>
  );
}
